import { useState } from "react";

import { ButtonV4, FieldV4, SelectV4 } from "../common/ui";
import type { OptionType } from "react-lib/apps/HISV3/common/CommonInterface";
import type { AdrAlert, AdrChoice } from "../common/sequence/OrderSheetV4";

// Types
type ModalAdrAlertV4Props = {
  // data
  alert: AdrAlert;
  reasonOptions: OptionType[];
  // callback
  onResolve: (choice: AdrChoice, reason: string) => void;
};

/** แจ้งเตือนแพ้ยา ก่อนเพิ่มยาเข้าใบคำสั่ง */
const ModalAdrAlertV4 = (props: ModalAdrAlertV4Props) => {
  const [reason, setReason] = useState("");

  const { alert } = props;

  const orderable = alert.warnings.filter((warning) => !warning.locked);

  const locked = alert.warnings.filter((warning) => warning.locked);

  // Handler
  const handleResolve = (choice: AdrChoice) => {
    setReason("");
    props.onResolve(choice, reason);
  };

  // Render
  return (
    <div className="hv4-modal hv4-modal-alert">
      <section
        role="alertdialog"
        aria-modal="true"
        aria-label="แจ้งเตือนแพ้ยา"
        className="hv4-card hv4-modal-card hv4-ord-adr"
      >
        <h2 className="hv4-card-title hv4-ord-adr-title">⛔ แจ้งเตือน: ผู้ป่วยแพ้ยากลุ่มนี้</h2>
        <p className="hv4-ord-adr-names">
          {alert.warnings.map((warning) => warning.name).join(", ")}
        </p>
        {alert.warnings.map((warning) => (
          <p key={warning.product} className="hv4-ord-adr-notes">
            {warning.notes}
          </p>
        ))}
        {locked.length > 0 && (
          <p className="hv4-ord-adr-locked">
            ห้ามสั่ง: {locked.map((warning) => warning.name).join(", ")}
          </p>
        )}
        {orderable.length > 0 && (
          <FieldV4
            label="เหตุผลที่ยังต้องสั่ง (บังคับเลือก · บันทึกไว้ในใบคำสั่ง)"
            htmlFor="hv4_ord_adr_reason"
          >
            <SelectV4
              id="hv4_ord_adr_reason"
              search
              allowAdd
              placeholder="เลือกหรือพิมพ์เหตุผล"
              options={props.reasonOptions}
              value={reason}
              onChange={setReason}
            />
          </FieldV4>
        )}
        <div className="hv4-ord-adr-actions">
          <ButtonV4 variant="ghost" onClick={() => handleResolve("cancel")}>
            ยกเลิก · ไม่สั่งยานี้
          </ButtonV4>
          {alert.entries.length > 1 && (
            <ButtonV4 variant="primary" onClick={() => handleResolve("skip")}>
              เพิ่มโดยไม่รวมยาที่แพ้
            </ButtonV4>
          )}
          {orderable.length > 0 && (
            <ButtonV4
              className="hv4-ord-adr-ok"
              disabled={!reason}
              onClick={() => handleResolve("order")}
            >
              ยืนยันสั่งต่อ
            </ButtonV4>
          )}
        </div>
      </section>
    </div>
  );
};

ModalAdrAlertV4.displayName = "ModalAdrAlertV4";

export default ModalAdrAlertV4;
